import { Component, OnInit, Input, ElementRef, ViewChild, OnDestroy } from '@angular/core';

@Component({
  selector: 'nc-aurora-text',
  templateUrl: './aurora-text.component.html',
  styleUrls: ['./aurora-text.component.less']
})
export class AuroraTextComponent implements OnInit, OnDestroy {
  /** 展示的文本内容 */
  private _text: string = '';
  @Input()
  set ncText(value: string) {
    this._text = value;
    setTimeout(() => {
      this.start();
    });
  }
  get ncText(): string {
    return this._text;
  }
  /** 颜色 */
  @Input() ncColors: string[] = ["#FF0080", "#7928CA", "#0070F3", "#38bdf8", "#a855f7", "#2dd4bf"];
  /** 速度 */
  @Input() ncSpeed: number = 1;

  @ViewChild('textContent') textContentRef!: ElementRef<HTMLSpanElement>;
  @ViewChild('svgText') svgTextRef!: ElementRef<SVGTextElement>;
  @ViewChild('canvas') canvasRef!: ElementRef<HTMLCanvasElement>;

  dimensions = { width: 0, height: 0 };
  isReady: boolean = false;
  textStyle: Partial<CSSStyleDeclaration> = {};
  maskId: string = `aurora-mask-${Math.random().toString(36).substring(2, 11)}`;

  private animationFrameId?: number;

  constructor() { }

  ngOnInit(): void {}

  ngOnDestroy(): void {
    this.clear();
  }

  private start(): void {
    this.clear();
    this.computeTextStyles();
    this.updateDimensions();
    this.startAnimation();
  }

  private clear(): void {
    if (this.animationFrameId) {
      cancelAnimationFrame(this.animationFrameId);
    }
  }

  private computeTextStyles(): void {
    if (this.textContentRef?.nativeElement) {
      const computedStyle = window.getComputedStyle(this.textContentRef.nativeElement);
      let relevantStyles = {};
      relevantStyles = this.extractTextStyles(computedStyle);
      this.textStyle = relevantStyles;
    }
  }

  private updateDimensions(): void {
    if (this.svgTextRef?.nativeElement) {
      try {
        const bbox = this.svgTextRef.nativeElement.getBBox();
        this.dimensions = {
          width: Math.max(1, bbox.width),
          height: Math.max(1, bbox.height)
        };
        this.isReady = true;
      } catch (e) {
        console.error('获取 SVG 元素尺寸时出错:', e);
      }
    }
  }

  private startAnimation(): void {
    const canvas = this.canvasRef?.nativeElement;
    if (!canvas) return;

    const ctx = canvas.getContext('2d');
    if (!ctx) return;

    let time = 0;
    const baseSpeed = 0.008;

    const animate = () => {
      if (!ctx || !canvas) return;

      if (canvas.width !== this.dimensions.width ||
        canvas.height !== this.dimensions.height) {
        canvas.width = this.dimensions.width;
        canvas.height = this.dimensions.height;
      }

      ctx.clearRect(0, 0, canvas.width, canvas.height);

      time += baseSpeed * this.ncSpeed;

      this.ncColors.forEach((color, i) => {
        const x =
          canvas.width *
          (0.5 +
            Math.cos(time * 0.8 + i * 1.3) * 0.4 +
            Math.sin(time * 0.5 + i * 0.7) * 0.2);
        const y =
          canvas.height *
          (0.5 +
            Math.sin(time * 0.7 + i * 1.5) * 0.4 +
            Math.cos(time * 0.6 + i * 0.8) * 0.2);

        const gradient = ctx.createRadialGradient(
          x,
          y,
          0,
          x,
          y,
          canvas.width * 0.4,
        );

        gradient.addColorStop(0, `${color}99`);
        gradient.addColorStop(0.5, `${color}33`);
        gradient.addColorStop(1, "#00000000");

        ctx.fillStyle = gradient;
        ctx.fillRect(0, 0, canvas.width, canvas.height);
      });

      this.animationFrameId = requestAnimationFrame(animate);
    };

    animate();
  }

  getStyleString(): string {
    let styleStr = '';
    for (const [key, value] of Object.entries(this.textStyle)) {
      if (value) {
        // 将驼峰命名转换为连字符命名
        const cssKey = key.replace(/([A-Z])/g, '-$1').toLowerCase();
        styleStr += `${cssKey}:${value};`;
      }
    }
    return styleStr;
  }

  // 提取文本相关样式的辅助方法
  private extractTextStyles(computedStyle: CSSStyleDeclaration): Partial<CSSStyleDeclaration> {
    return {
      fontSize: computedStyle.fontSize,
      fontFamily: computedStyle.fontFamily,
      fontWeight: computedStyle.fontWeight,
      fontStyle: computedStyle.fontStyle,
      letterSpacing: computedStyle.letterSpacing,
      lineHeight: computedStyle.lineHeight,
      textTransform: computedStyle.textTransform,
      fontVariant: computedStyle.fontVariant,
      fontStretch: computedStyle.fontStretch,
      fontFeatureSettings: computedStyle.fontFeatureSettings,
      textDecoration: computedStyle.textDecoration,
      textShadow: computedStyle.textShadow,
    };
  }
}
